import React, { FunctionComponent } from "react"
import { Controller, useFormContext } from "react-hook-form"
import { assetTypes } from "../../../api/Definitions"
import FormInput from "../../../components/Form/Inputs/FormInput"
import SelectInput from "../../../components/Form/Select/Select"
import Upload from "../../../components/Upload/Upload"
import { iAsset } from "../../../definitions/Assets"

interface iProps {
  item?: iAsset
}

const AssetOverview: FunctionComponent<iProps> = ({ item }) => {
  const { watch } = useFormContext()

  const { type }: Partial<iAsset> = watch(["type"])

  return (
    <div className="scrollable">
      <FormInput name="title" label="Title" />
      <Controller
        as={SelectInput}
        name="type"
        options={assetTypes}
        label="Type"
      />
      {type !== "IMAGE" && (
        <Upload
          name="preview"
          fileCollection="Files_AssetPreview"
          initialFiles={[item?.preview || ""]}
          fileType={["image/png", "image/jpeg"]}
          label="Upload preview"
          maxFiles={1}
        />
      )}
      {type === "VIDEO" && (
        <Upload
          name="video"
          fileCollection="Files_VideoAssets"
          label="Upload video"
          maxFiles={1}
          initialFiles={[item?.video || ""]}
        />
      )}
      {type !== "LAMP" && type !== "VIDEO" && (
        <>
          <Upload
            name="file"
            fileCollection="Files_Assets"
            initialFiles={[item?.file || ""]}
            label="Upload file"
            maxFiles={1}
          />
          <FormInput name="meshguid" label="Mesh GUID" />
        </>
      )}
      {type === "LAMP" && (
        <>
          <Upload
            name="cookie"
            fileCollection="Files_LightCookie"
            initialFiles={[item?.cookie || ""]}
            label="Upload cookie"
            maxFiles={1}
          />
          <Upload
            name="iesProfile"
            fileCollection="Files_IESProfiles"
            initialFiles={[item?.iesProfile || ""]}
            label="Upload IES Profile"
            maxFiles={1}
          />
        </>
      )}
    </div>
  )
}

export default AssetOverview
